import { gql } from '@apollo/client';

const DEVICE_EVENT_COUNT_QUERY = gql`
  query deviceEventsCountV2($filter: DeviceEventsInput) {
    deviceEventsCountV2(filter: $filter) {
      notificationEvents
      patientTriggeredEvents
      otherEvents
    }
  }
`;

export default DEVICE_EVENT_COUNT_QUERY;
